// eslint-disable-next-line no-restricted-imports
import { MutationInput_LegalClientController_SaveOnboardingStatus_Input_Value as LegalClientOnboardingStatusTypeApi } from 'api/generated/graphql';
import {
  LegalClientOnboardingStatusType,
  OnboardingStatusType,
} from 'api/types/entity';

const statusMap: Record<
  LegalClientOnboardingStatusType,
  LegalClientOnboardingStatusTypeApi
> = {
  [OnboardingStatusType.FillingOut]:
    LegalClientOnboardingStatusTypeApi.FillingOut,
  [OnboardingStatusType.AccountOpened]:
    LegalClientOnboardingStatusTypeApi.AccountOpened,
  [OnboardingStatusType.ComplianceCheck]:
    LegalClientOnboardingStatusTypeApi.ComplianceCheck,
  [OnboardingStatusType.AccountOpeningDenied]:
    LegalClientOnboardingStatusTypeApi.AccountOpeningDenied,
  [OnboardingStatusType.AmlCftCheck]:
    LegalClientOnboardingStatusTypeApi.AmlCftCheck,
  [OnboardingStatusType.AccountOpening]:
    LegalClientOnboardingStatusTypeApi.AccountOpening,
  [OnboardingStatusType.AwaitingAccountOpening]:
    LegalClientOnboardingStatusTypeApi.AwaitingAccountOpening,
  [OnboardingStatusType.AwaitingAmlCftCheck]:
    LegalClientOnboardingStatusTypeApi.AwaitingAmlCftCheck,
  [OnboardingStatusType.AwaitingComplianceCheck]:
    LegalClientOnboardingStatusTypeApi.AwaitingComplianceCheck,
  [OnboardingStatusType.AwaitingValidation]:
    LegalClientOnboardingStatusTypeApi.AwaitingValidation,
  [OnboardingStatusType.BoardReview]:
    LegalClientOnboardingStatusTypeApi.BoardReview,
  [OnboardingStatusType.ValidationCheck]:
    LegalClientOnboardingStatusTypeApi.ValidationCheck,
  [OnboardingStatusType.PendingBoardReview]:
    LegalClientOnboardingStatusTypeApi.PendingBoardReview,
  [OnboardingStatusType.SigningDocuments]:
    LegalClientOnboardingStatusTypeApi.SigningDocuments,
  [OnboardingStatusType.AwaitingPaymentConfirmation]:
    LegalClientOnboardingStatusTypeApi.AwaitingPaymentConfirmation,
  [OnboardingStatusType.SigningQuestionnaire]:
    LegalClientOnboardingStatusTypeApi.SigningQuestionnaire,
};

export const parseLegalClientOnboardingStatusParam = (
  onboardingStatus: LegalClientOnboardingStatusType
): LegalClientOnboardingStatusTypeApi => statusMap[onboardingStatus];
